import { DriverAcknowledge } from "../DriverAcknowledge";
import { DriverChoice } from "../DriverChoice";
import { DriverChoiceManualSearch } from "../DriverChoiceManualSearch";
import { Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutDriverPortal extends Layout {
	layoutAcknowledge: DriverAcknowledge;
	layoutDriverChoice: DriverChoice;
	layoutManualSearch: DriverChoiceManualSearch;
	tabDriverAcknowledge: Tab;
	tabManualSearch: Tab;
	tabMyMatchingLoads: Tab;
	tabset1: Tabset;
}
